export default [
  {
    path: '/postalIndex',
    name: 'postalIndex',
    meta: { title: '邮储新客' },
    component: () => import('../../views/postalNewCustomer/index.vue')
  },
  {
    path: '/postalShareIndex',
    name: 'postalShareIndex',
    meta: { title: '绿色出行 “邮”享好礼' },
    component: () => import('../../views/postalNewCustomer/shareIndex.vue')
  },
  {
    path: '/postalTurnTable',
    name: 'postalTurnTable',
    meta: { title: '每日抽奖' },
    component: () => import('../../views/postalNewCustomer/turntable.vue')
  },
  {
    path: '/newCustomerRule',
    name: 'newCustomerRule',
    meta: { title: '规则说明' },
    component: () => import('../../views/postalNewCustomer/rule.vue')
  },
  {
    path: '/newTurntablRule',
    name: 'newTurntablRule',
    meta: { title: '规则说明' },
    component: () => import('../../views/postalNewCustomer/turntableRule.vue')
  },
  {
    path: "/post-my-reward",
    name: "reward",
    meta: { title: "我的奖励" },
    component: () => import("@/views/postalNewCustomer/MyReward")
  },
  {
    path:"/openingMode",
    name:'openingMode',
    meta:{title:'邮政储蓄银行数币钱包开通教程'},
    component: () => import("@/views/postalNewCustomer/openingMode")
  },
  {
    path: "/postalRules",
    name: "postalRules",
    meta: { title: "使用规则" },
    component: () => import("@/views/postalNewCustomer/RewardRulePage")
  }
]
